export * from './lib/promotion-banner/promotion-banner.component';
